import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <>
    <circle cx="12" cy="12" r="11" fill="#1D8549" />
    <path
      fill="#FFFFFF"
      d="M11 16.333c-.267 0-.533-.133-.733-.333l-3.334-3.667c-.4-.4-.333-1.066.067-1.4.4-.4 1.067-.333 1.4.067l2.533 2.8 4.6-6.067c.334-.466.934-.533 1.4-.2.467.334.534.934.2 1.4l-5.333 7a.95.95 0 01-.8.4z"
    />
  </>,
  'GreenCheck'
)
